import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get_automation_linked_dataset_from_url_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { LINKED_DATASETS_KEY } from '@/utils/queryKeys.ts';
import { LinkedDataset } from '@/types/datasets.ts';

type props = {
  name?: string;
  integration_id: string;
  url: string;
};

const useCreateLinkedDatasetFromURL = (
  options?: UseMutationOptions<LinkedDataset, AxiosError, props>,
): UseMutationResult<LinkedDataset, AxiosError, props> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (args: props) => {
      const response = await apiClient.post(
        get_automation_linked_dataset_from_url_url(automationId),
        args,
      );

      await queryClient.invalidateQueries({ queryKey: LINKED_DATASETS_KEY(automationId) });

      return response.data;
    },
    ...options,
  });
};

export default useCreateLinkedDatasetFromURL;
